import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Typography from "@mui/material/Typography";
import { campaignCTAs, routes } from "../../utils/constants"
import CampaignSummary from '../../components/CampaignSummary';
import { getSummary, hideSummaryAction } from '../../components/CampaignSummary/campaignSummaryReducer';
import { createNewCampaign, getAttributes, getProductSegment, setStep, setViewCampaignSelected } from '../CreateCampaigns/createCampaignReducer';
import { createCampaignQuery } from '../CreateCampaigns/constants'
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { showLoader } from '../../components/Loader/loaderReducer';
import { usePrevious } from '../../utils/customHooks';
import { getComment, getUpdateCampaignPayload } from '../CreateCampaigns/helpers';

const CampaignDetails = () => {
    const { campaignId } = useParams();
    const categoryLength = useSelector(state => state.createCampaign.productSegment?.data?.length || 0);
    const prevCategoryLength = usePrevious(categoryLength);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const summary = useSelector(state => state.campaignSummary.summary);
    const loading = useSelector(state => state.campaignSummary.loading);
    const error = useSelector(state => state.campaignSummary.error);
    useEffect(() => {
            dispatch(showLoader());
            dispatch(getProductSegment({entityType:createCampaignQuery.product}));
            dispatch(getAttributes({entityType:createCampaignQuery.customer}));
            dispatch(getSummary(campaignId));
    }, []);

    const onEdit = (step) => {
        dispatch(hideSummaryAction());
        dispatch(setViewCampaignSelected(summary));
        dispatch(setStep(step));
        navigate(routes.createCampaign);
    }

    const handlePauseCampaign = () => {
        dispatch(createNewCampaign({
            campaignData: getUpdateCampaignPayload({ ...summary, comment: getComment(summary), status: "INACTIVE" }),
            requestType: campaignCTAs.pause
        }))
    }

    const handleResumeCampaign = () => {
        dispatch(createNewCampaign({
            campaignData: getUpdateCampaignPayload({ ...summary, comment: getComment(summary), status: "ACTIVE" }),
            requestType: campaignCTAs.resume
        }))
    }

    const onSubmit = (requestType) => {
        if (requestType === campaignCTAs.decline) {
            const campaignData = getUpdateCampaignPayload({ ...summary, isDeclined: true  });
            dispatch(createNewCampaign({
                campaignData,
                requestType
            }))
        }
    }

    if (!loading && !isEmpty(summary)) {
        return <CampaignSummary onEdit={onEdit} onSubmit={onSubmit} onPause={handlePauseCampaign} onResume={handleResumeCampaign} />
    }

    if (!loading && error) {
        return <Typography component="div" sx={{ textAlign: "center" }}>No data found!</Typography>
    }

    return null;
}

export default CampaignDetails;